import React, { useState, useContext, useEffect } from 'react';
import CleanTechFull from '../../images/cleantech-full.png';
import { FirebaseContext } from '../../context/firebase';
import { Link, Redirect, useHistory } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import * as PROJECT_CODE from '../../constants/projectCode';
import {
	Checkbox,
	FormControlLabel,
	makeStyles,
	TextField,
	InputAdornment,
	IconButton,
} from '@material-ui/core';
import SignInOptions from '../signInOptions/SignInOptions';
import companyLogoFull from '../../images/companyLogoFull.png';
import glenridgeLogo from '../../images/glenridgeLogo.png';
import ambriaLogo from '../../images/ambriaLogo.png';
import SignUpOptions from '../signInOptions/SignUpOptions';
import {
	signUpWithEmail,
	setRedirect,
	clearError,
} from '../../redux/signIn/actions';
import { connect } from 'react-redux';
import CustomAlerts from '../alerts/CustomAlerts';
import { getProfile } from '../../redux/profile/action';
import {
	reformatPhoneString,
	validatePhoneNumber,
} from '../../utils/validatePhoneNumber';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const mapStateToProps = (state) => {
	return {
		errorMessage: state.signIn.error,
		redirect: state.signIn.redirect,
		userType: state.signIn.userType,
	};
};

function SignUp(props) {
	const history = useHistory();
	const { firebase } = useContext(FirebaseContext);
	const [snackbar, setSnackbar] = useState(false);
	const [formData, setFormData] = useState({
		fullName: '',
		email: '',
		telNumber: '',
		password: '',
		confirmPassword: '',
		check: false,
	});
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const { fullName, email, telNumber, password, confirmPassword, check } =
		formData;

	const [error, setError] = useState('');

	const {
		signUpWithEmail,
		setRedirect,
		errorMessage,
		redirect,
		userType,
		getProfile,
		clearError,
	} = props;

	useEffect(() => {
		setError(errorMessage);
		setSnackbar(true);
		setTimeout(() => {
			setError('');
			clearError();
		}, 4000);
	}, [errorMessage]);

	useEffect(() => {
		if (redirect) {
			history.push('/');
			setRedirect(false);
		}
	}, [redirect, userType]);

	const onChange = (e) => {
		let value;
		if (
			e.target.name === 'telNumber' &&
			validatePhoneNumber(e.target.value)
		) {
			value = reformatPhoneString(e.target.value);
		}
		setFormData({
			...formData,
			[e.target.name]: value ? value : e.target.value,
		});
	};

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const handleClickShowConfirmPassword = () => {
		setShowConfirmPassword(!showConfirmPassword);
	};

	const handleSignUp = async (e) => {
		e.preventDefault();

		var phoneRef =
			/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
		var emailRef = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

		if (
			fullName === '' ||
			email === '' ||
			telNumber === '' ||
			password === '' ||
			confirmPassword === ''
		) {
			displayAlert('Please fill in all the fields.');
		} else if (!emailRef.test(email)) {
			displayAlert('Invalid email address.');
		} else if (!phoneRef.test(telNumber)) {
			displayAlert('Invalid phone number.');
		} else if (password !== confirmPassword) {
			displayAlert('Password does not match.');
		} else if (check === false) {
			displayAlert('You have to accept the terms and conditions.');
		} else {
			await signUpWithEmail(email, password, fullName, telNumber);
			getProfile();
		}
	};
	const displayAlert = (message) => {
		setError(message);
		setSnackbar(true);
		setTimeout(() => {
			setSnackbar(false);
		}, 3500);
	};
	const useStyles = makeStyles({
		fieldStyle: {
			width: '100%',
		},
		title: {
			marginBottom: '30px',
			textAlign: 'center',
			fontWeight: 400,
			fontSize: 18,
		},
	});

	const styles = useStyles();

	const privacyPolicy = () => {
		return (
			<small>
				I accept the{' '}
				<a href='https://www.kavtek.com/privacy-policy/'>
					Terms & Conditions
				</a>
			</small>
		);
	};

	return (
		<>
			<div className='signin-form'>
				<form
					className='form formSignUp'
					onSubmit={handleSignUp}
					method='POST'
					noValidate
					autoComplete='off'
				>
					<div className='image-assets'>
						<img src={ambriaLogo} alt='Company Logo' />
					</div>
					{error && (
						<CustomAlerts
							alertType='error'
							alertMsg={error}
							snackbar={snackbar}
							setSnackbar={setSnackbar}
						/>
					)}
					<p className={styles.title}>Create a new account</p>
					<div className='form-group'>
						<TextField
							type='text'
							label='Full Name'
							name='fullName'
							value={fullName}
							onChange={(e) => onChange(e)}
							variant='outlined'
							className={styles.fieldStyle}
							autoComplete='off'
						/>
					</div>
					<div className='form-group'>
						<TextField
							type='email'
							label='Email Address'
							name='email'
							value={email}
							autoComplete='false'
							onChange={(e) => onChange(e)}
							variant='outlined'
							className={styles.fieldStyle}
						/>
					</div>
					<div className='form-group'>
						<TextField
							type='tel'
							pattern='[0-9]{3}[0-9]{3}[0-9]{4}'
							label='Phone Number (1231231234)'
							name='telNumber'
							value={telNumber}
							autoComplete='false'
							onChange={(e) => onChange(e)}
							variant='outlined'
							className={styles.fieldStyle}
						/>
					</div>
					<div className='form-group'>
						<TextField
							type={showPassword ? 'text' : 'password'}
							label='Password'
							name='password'
							minLength='6'
							value={password}
							autoComplete='off'
							autoCorrect='off'
							autocomplete='false'
							onChange={(e) => onChange(e)}
							variant='outlined'
							className={styles.fieldStyle}
							InputProps={{
								endAdornment: (
									<InputAdornment
										position='end'
										className={styles.margin}
									>
										<IconButton
											aria-label='toggle password visibility'
											onClick={handleClickShowPassword}
											onMouseDown={
												handleMouseDownPassword
											}
										>
											{showPassword ? (
												<Visibility />
											) : (
												<VisibilityOff />
											)}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</div>
					<div className='form-group'>
						<TextField
							type={showConfirmPassword ? 'text' : 'password'}
							autoComplete='off'
							autoCorrect='off'
							label='Confirm Password'
							name='confirmPassword'
							minLength='6'
							value={confirmPassword}
							onChange={(e) => onChange(e)}
							variant='outlined'
							className={styles.fieldStyle}
							InputProps={{
								endAdornment: (
									<InputAdornment
										position='end'
										className={styles.margin}
									>
										<IconButton
											aria-label='toggle confirm password visibility'
											onClick={
												handleClickShowConfirmPassword
											}
											onMouseDown={
												handleMouseDownPassword
											}
										>
											{showConfirmPassword ? (
												<Visibility />
											) : (
												<VisibilityOff />
											)}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</div>
					<FormControlLabel
						control={
							<Checkbox
								checked={check}
								onChange={(e) => {
									setFormData({ ...formData, check: !check });
								}}
								name='check'
								color='primary'
							/>
						}
						label={privacyPolicy()}
					/>

					<input
						type='submit'
						className='signupbtn btn btn-primary d-block mr-0 m-auto'
						value='Register'
					/>

					<div className='line-separator'>Or</div>
					<SignUpOptions
						check={formData.check}
						setError={setError}
						error={error}
					/>
					<small className='small-login-text flex-center'>
						Already have an Account?&nbsp;
						<Link to='/signin'> Login Here</Link>
					</small>
				</form>
			</div>
		</>
	);
}

export default connect(mapStateToProps, {
	signUpWithEmail,
	setRedirect,
	getProfile,
	clearError,
})(SignUp);
